import React from "react";
import "./style.css";
import { Container } from "@material-ui/core";
import { Menu } from "@material-ui/icons";
import { NavLink } from "react-router-dom";
export default function Header() {
  return (
    <Container>
      <nav>
        <h2 id="logo">Versus</h2>
        <label for="drop" class="toggle">
          <Menu />
        </label>
        <input type="checkbox" id="drop" />
        <ul class="menu">
          <li>
            <NavLink to="/">HOME</NavLink>
          </li>
          <li>
            <label for="drop-2" class="toggle">
              CATEGORIES +
            </label>
            <a href="#">CATEGORIES</a>
            <input type="checkbox" id="drop-2" />
            <ul>
              <li>
                <a href="#">Resources 1</a>
              </li>
              <li>
                <a href="#">Resources 2</a>
              </li>
              <li>
                <label for="drop-3" class="toggle">
                  Tutorials +
                </label>
                <a href="#">Tutorials</a>
                <input type="checkbox" id="drop-3" />

                <ul>
                  <li>
                    <a href="#">HTML/CSS</a>
                  </li>
                  <li>
                    <a href="#">jQuery</a>
                  </li>
                  <li>
                    <a href="#">Other</a>
                  </li>
                </ul>
              </li>
            </ul>
          </li>
          {/** 
            <li>
            <label for="drop-1" class="toggle">
            SMARTPHONES +
            </label>
            <a href="#">SMARTPHONES</a>
            <input type="checkbox" id="drop-1" />
            <ul>
            <li>
            <a href="#">Category 1</a>
            </li>
            <li>
            <a href="#">Category 2</a>
            </li>
            <li>
            <a href="#">Category 3</a>
            </li>
            </ul>
            </li>
          */}
          <li>
            <NavLink to="/compare/smartphones" >SMARTPHONES</NavLink>
          </li>
          <li>
            <NavLink to="/compare/smartwatches">SMARTWATCHES</NavLink>
          </li>
          <li>
            <NavLink to="/compare/headphones">HEADPHONES</NavLink>
          </li>
          <li>
            <NavLink to="/compare/tablets">TABLETS</NavLink>
          </li>
        </ul>
        <div id="mobile-auth">
          <p id="auth">
            <NavLink to="/login">SIGN IN</NavLink>
          </p>
          <p id="auth">
            <NavLink to="/signup">SIGN UP</NavLink>
          </p>
        </div>
      </nav>
    </Container>
  );
}
